import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type13CodeUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type13Code", configService);
    }
}
